export const servicesData = [
    {
        Icon:'ri-quill-pen-line',
        NameFirst:'تصميم ',
        NameLast:'المواقع',
        Describe:'استطيع تصميم موقع متكامل متجاوب مع جميع الاجهزة'
    },
    {
        Icon:'ri-braces-line',
        NameFirst:'برمجة ',
        NameLast:'المواقع',
        Describe:'استطيع برمجة المواقع بشكل احترافى وبكود نظيف وسهل على مبرمج اخر قراءته'
    },
    {
        Icon:'ri-layout-4-line',
        NameFirst:'تطوير ',
        NameLast:'المواقع',
        Describe:'استطيع تعديل وتطوير الموقع الخاص بك واضافة الاشياء التى تريدها'
    },
]

